export default __webpack_public_path__ + "static/media/a015-arrow.83822dbe.svg";